/** get items column */
import { TagsCreateBy } from "../../badge-and-tag";
import { Typography, Switch, Button, Tooltip } from "antd";
import { EditOutlined } from "@ant-design/icons";
import {
  EditableRow,
  EditableCell,
} from "../../../components/table/TableEditAble";

/** export component for edit table */
export const componentsEditable = {
  body: { row: EditableRow, cell: EditableCell },
};

export const ACTIVE_ON = "เปิดใช้งาน";
export const ACTIVE_OFF = "ปิดใช้งาน";
export const isActive = (v) => String(v || "").trim() !== ACTIVE_OFF;

export const columns = ({ handleChoose, handleEdit, handleToggle }) => {
  const Link = Typography.Link;
  return [
    {
      title: "Microbiological Name",
      key: "micro_master_name",
      dataIndex: "micro_master_name",
      render: (v, record) =>
        /* รายการที่ปิดใช้งานเลือกไปใช้ไม่ได้ แสดงเป็นตัวเทาแทนลิงก์ */
        isActive(record.active_status) ? (
          <Link className="text-select" onClick={() => handleChoose(record)}>
            {v}
          </Link>
        ) : (
          <Typography.Text type="secondary" delete>
            {v}
          </Typography.Text>
        ),
    },
    {
      title: "เปิดใช้งาน",
      dataIndex: "active_status",
      key: "active_status",
      width: 130,
      align: "center",
      render: (v, record) => (
        <Switch
          size="small"
          checked={isActive(v)}
          checkedChildren="เปิด"
          unCheckedChildren="ปิด"
          onChange={(checked) => handleToggle(record, checked)}
        />
      ),
    },
    {
      title: "จัดทำโดย",
      dataIndex: "created_name",
      key: "created_name",
      sorter: (a, b) => (a.created_name || "").localeCompare(b.created_name || ""),
      width: "20%",
      ellipsis: {
        showTitle: false,
      },
      render: (data, role) => <TagsCreateBy result={data} role={role} />,
    },
    {
      title: "",
      key: "action",
      width: 60,
      align: "center",
      fixed: "right",
      render: (_, record) => (
        <Tooltip title="แก้ไข">
          <Button
            size="small"
            icon={<EditOutlined />}
            className="bn-primary-outline"
            style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
            onClick={() => handleEdit(record)}
          />
        </Tooltip>
      ),
    },
  ];
};

export const defaultParamenterMicro = [
  {
    seq: 1,
    micro_name: "Total Plate Count",
    limit_number: "<1000",
    remark: null,
  },
  {
    seq: 2,
    micro_name: "Yeast & Mold",
    limit_number: "<100",
    remark: null,
  },
  {
    seq: 3,
    micro_name: "%Coliforms",
    limit_number: "<3.0",
    remark: null,
  },
];

export const micro_nameMicroColumns = ({ handleAction, nameOption }) => {
  return [    
    {
      title: "Parameter Name",
      key: "micro_name",
      dataIndex: "micro_name",
      editable: true,
      required: true,
      align: "left",
      width: 200,
      className: "field-edit",
      type: "autocomplete",
      autocompleteOption: nameOption,
    },
    {
      title: "Preparation Value",
      align: "left",
      width: 100,
      editable: true,
      required: false,
      key: "limit_number",
      dataIndex: "limit_number",
      className: "field-edit",
      type: "input",
    },
    {
      title: "Unit",
      align: "left",
      width: 100,
      editable: true,
      required: false,
      key: "unit",
      dataIndex: "unit",
      className: "field-edit",
      type: "input",
    },
    {
      title: "Remark",
      align: "left",
      key: "remark",
      dataIndex: "remark",
      editable: true,
      required: false,
      type: "input",
      className: "field-edit",
    },
    {
      title: "ตัวเลือก",
      align: "center",
      key: "operation",
      dataIndex: "operation",
      render: (_, record, idx) => handleAction(record),
      width: "90px",
      fixed: "right",
    },
  ];
};

export const columnsMicroParametersEditable = (
  handleSave,
  { handleAction, nameOption }
) => {
  const col = micro_nameMicroColumns({ handleAction, nameOption });
  return col.map((col, ind) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => {
        // console.log(record);
        return {
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave,
          fieldType: !!col?.textArea,
          required: !!col?.required,
          type: col?.type || "input",
          autocompleteOption: col.autocompleteOption,
        };
      },
    };
  });
};
